import { render, staticRenderFns } from "./promotionInfo.vue?vue&type=template&id=3d1fb85b&scoped=true&"
import script from "./promotionInfo.vue?vue&type=script&lang=js&"
export * from "./promotionInfo.vue?vue&type=script&lang=js&"
import style0 from "./promotionInfo.vue?vue&type=style&index=0&id=3d1fb85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1fb85b",
  null
  
)

export default component.exports